import * as React from 'react';
import { ClassName } from '../../utils/utils';

interface IAlertProps {
  children: any;
  type?: string;
  visible: boolean;
  onTimeout?: () => any;
}

class Alert extends React.Component<IAlertProps> {

  private timeout: any;

  constructor(props: IAlertProps) {
    super(props);

    this.state = {
      isVisible: this.props.visible
    };
  }

  public onTimeout() {
    clearTimeout(this.timeout);
    if (!this.props.onTimeout) {
      return;
    }
    this.props.onTimeout();
  }

  public render() {
    clearTimeout(this.timeout);

    const { children, type, visible, onTimeout } = this.props;

    if (visible && onTimeout) {
      this.timeout = setTimeout(() => { this.onTimeout(); }, 5000);
    }

    return (
      <div onClick={() => { this.onTimeout(); }} className={ClassName('flashMessage', [type]) + (this.props.visible ? ' isVisible' : '')}>
        {children}
      </div>
    );
  }
}

export default Alert;



// WEBPACK FOOTER //
// ./src/modules/Alert/Alert.tsx